<div class="modal-header">
  <h5 class="modal-title">
    Terms and Conditions
  </h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')"></button>
</div>

<div class="modal-body p-4">
  <p>
    <strong>
      Our Terms and Conditions have recently changed, please review and confirm that you agree to them before continuing
      to use TRACit.
    </strong>
  </p>

  <hr>

  <app-terms-text></app-terms-text>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-danger text-white me-auto" (click)="cancel()">
    Deny
  </button>

  <button type="button" class="btn btn-success text-white" (click)="accept()">
    Accept
  </button>
</div>
